import { ColorPickerField } from './ColorPickerField'
import { ColorPickerPopover } from './ColorPickerPopover'

export const COLOR_PICKER_MENU = [
  'Color picker',
  [
    ['Form input field', ColorPickerField],
    ['Popover', ColorPickerPopover],
  ],
]
